import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Logo } from '../Logo/Logo';
import './Login.css';

export const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await login({ email, senha });
      // Check role from localStorage (just set by login)
      const storedUser = localStorage.getItem('usuario');
      if (storedUser) {
        const userData = JSON.parse(storedUser);
        const normalizedRole = String(userData.role || '').trim().toLowerCase();
        if (['super_admin', 'super-admin', 'superadmin'].includes(normalizedRole)) {
          navigate('/admin');
          return;
        }
      }
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.message || 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo-container">
          <Logo size="large" />
        </div>
        <p className="subtitle">Sistema de Gestão de Leads</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="seu@email.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="senha">Senha</label>
            <input
              type="password"
              id="senha"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              required
              placeholder="••••••••"
            />
            <Link to="/forgot-password" className="forgot-password-link">Esqueci minha senha</Link>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" disabled={loading} className="login-button">
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <div className="login-info">
          <p>Ainda no tem conta? <a href="/register">Cadastre-se</a></p>
        </div>
      </div>
    </div>
  );
};
